export const defaultCenterMap = [37.4447144485548, 15.047330340065132]

export const idTiplogiaTrattore = 1
export const idTiplogiaRimorchio = 0


export const serviceTypeList = [
  { id: 0, name: "controllo" },
  { id: 1, name: "manutenzione" }
];

export const serviceStatusList = [
  { id: 0, name: "TO_DO" },
  { id: 1, name: "COMPLETED" }
];

export const DIRECTION_VALUES = {
  OUTWARD: "SUD / NORD",
  RETURN: "NORD / SUD"
}


export const noteTypeList = ["Fermo", "Cambio", "Varie", "Nota"]


export const NotificationTypeList = ["NOTICE", "ALARM"]

export const entityKeys = [
  "VEHICLE", "USER", "TASK", "FLEET",
  "SERVICE", "COMPANY", "DEALER",
  "DEVICE", "JOURNEY", "METADATA",
  "NOTE", "ROLE", "SERVICE_PLAN",
  "SERVICE_PLAN_MODEL", "TASK_MODEL", "VEHICLE_TYPE"
]

export const actionKeys = [
  "CREATE", "READ", "UPDATE", "DELETE"
]


export const getStatusColor = (status) => {
  switch (status) {
    case 'Open':
      return 'success';
    case 'Attivo':
      return 'success';
    case 'completed':
      return 'success';
    case 'COMPLETED':
      return 'success';
    case 'planned':
      return 'warning';
    case 'TO_DO':
      return 'warning';
    case 'Sospeso':
      return 'warning';
    case 'Closed':
      return 'danger';
    case 'Error':
      return 'danger';
    default:
      return 'dark';
  }
}

export const getBadgeVehicleStatus = (status) => {
  switch (status) {
    case 'movement':
      return 'success';
    case 'Running':
      return 'success';
    case 'd':
      return 'warning';
    case 'Stopped':
      return 'danger';
    case 'Error':
      return 'danger';
    default:
      return 'dark';
  }
}

export const defaultMenuType = 'menu-default';
export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'it';
export const localeOptions = [
  { id: 'it', name: 'Italiano', direction: 'ltr' },
  { id: 'en', name: 'English', direction: 'ltr' },
];

export const adminRoot = '/app';
export const searchPath = `${adminRoot}/#`;

/* TEMPLATE */
export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = false;
export const defaultColor = 'light.bluenavy';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
];

